import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import useStyles from "../../styles";

export default function MembershipTableComponent({ data, isExpired, currentPage, totalPages, onPreviousPage, onNextPage, onClick, accumulatedItems, totalItems }) {
  const classes = useStyles();

  if (data == null || data == [] || !!(data)) {
  } else {
    var keys = Object.keys(data[0]).map(i => i.toUpperCase());
    keys.shift();
  }

  return (
    <>
      <Table className="mb-0">
        <TableHead>
          <TableRow className={classes.root}>
            <TableCell size='small' style={{ textAlign: 'center', fontSize: "14px" }} >NOMBRE</TableCell>
            <TableCell size='small' style={{ textAlign: 'center', fontSize: "14px" }} >TIPO DE MEMBRECÍA</TableCell>
            <TableCell size='small' style={{ textAlign: 'center', fontSize: "14px" }} >FECHA DE VENCIMIENTO</TableCell>
            {/*{keys.map(key => (
            <TableCell key={key}>{key}</TableCell>
          ))}*/}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map(({ id, name, lastName, membershipType, dueDate }) => (
            <TableRow style={{ height: "20px" }} key={id}
            //onClick={onClick(id)}
            >
              <TableCell size='small' padding='none' className={classes.tableTextStyle} style={{ fontSize: "14px" }} >{name + " " + lastName}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle} style={{ fontSize: "14px" }} >{membershipType}</TableCell>
              <TableCell size='small' padding='none' className={isExpired ? classes.membershipExpired : classes.nextMembershipToExpire} style={{ fontSize: "14px", textAlign: "center" }}>{dueDate}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className={classes.footerTable}>
        <div className={classes.footerTableFirstDiv}>
          <p className={classes.footerText}>TOTAL: {accumulatedItems} DE {totalItems}</p>
        </div>

        <div className={classes.footerTableSecondDiv}>
          <p className={classes.footerText}>PÁGINA: {currentPage} DE {totalPages}</p>
          <div className={currentPage == 1 ? classes.buttonPageDisableArrowDiv :
            classes.buttonPageEnableArrowDiv}>
            <Icons.ArrowBackIos className={currentPage == 1 ?
              classes.buttonPageDisableArrow : classes.buttonPageEnableArrow}
              onClick={currentPage == 1 ? null : onPreviousPage}
            />
          </div>
          <div className={classes.spaceBetweenButtons}></div>
          <div className={currentPage == totalPages ? classes.buttonPageDisableArrowDiv :
            classes.buttonPageEnableArrowDiv}>
            <Icons.ArrowForwardIos className={currentPage == totalPages ?
              classes.buttonPageDisableArrowForward : classes.buttonPageEnableArrowForward}
              onClick={currentPage == totalPages ? null : onNextPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
